(function () {
    const qs = (s, el = document) => el.querySelector(s);
    const qsa = (s, el = document) => Array.from(el.querySelectorAll(s));
    const html = document.documentElement;
    const drawer = qs('#ially-mobile-nav');
    const overlay = qs('[data-menu-overlay]');
    const btnOpen = qs('[data-menu-toggle]');
    const btnClose = qs('[data-menu-close]');
  
    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      if (overlay) overlay.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      if (btnOpen) btnOpen.setAttribute('aria-expanded', 'true');
      html.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      if (btnOpen) btnOpen.setAttribute('aria-expanded', 'false');
      setTimeout(() => {
        drawer.hidden = true;
        if (overlay) overlay.hidden = true;
      }, 200);
      html.style.overflow = '';
    }
  
    btnOpen && btnOpen.addEventListener('click', openDrawer);
    btnClose && btnClose.addEventListener('click', closeDrawer);
    overlay && overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
  
    // Accordions (mobile)
    qsa('[data-accordion]').forEach((btn) => {
      const container = btn.closest('.mobile-item');
      const sub = container && qs('.mobile-sublist', container);
      if (!sub) return;
      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        sub.hidden = expanded;
      });
    });
  })();
  